// extracted by mini-css-extract-plugin
export default {"searchBar":"_19poh","fixedText":"_2EN8_","animatedTextContainer":"_3guCQ","animatedTextWrapper":"_15py_","animatedWord":"_3ToWC"};